import { useState } from 'react'
import { selectedMemberRow } from './indyMemberSelection.js'
import styles from './IndyMemberActions.module.css'

const REVIEW_ACTIONS = Object.freeze([
  { kind: 'art', label: 'Review Art' }, { kind: 'quote', label: 'Review Quote' },
  { kind: 'campaign', label: 'Review Email' }, { kind: 'win', label: 'Review Win' },
])

export default function IndyMemberActions({ summary, onOpen, onAction }) {
  const [choice, setChoice] = useState(null)
  const selectedId = choice && choice.summaryId === summary?.id ? choice.memberId : ''
  const current = selectedMemberRow(summary, selectedId)
  const selected = current?.record === choice?.record ? current : null
  const choose = (action) => {
    // Resolve again against current props at the gesture boundary, not a cached row.
    const actual = selectedMemberRow(summary, selectedId)
    if (actual && actual.record === choice?.record) onAction?.(action, actual)
  }
  return <div className={styles.chooser} data-testid="indy-member-actions">
    <label>Choose an actual member record
      <select className="input" aria-label="Individual member record" value={selected ? selectedId : ''}
        onChange={(event) => {
          const row = selectedMemberRow(summary, event.target.value)
          setChoice(row ? { summaryId: summary.id, memberId: row.id, record: row.record } : null)
        }}>
        <option value="">Choose a record before acting</option>
        {(summary?.memberRecords || []).map((record) => <option key={record.id} value={record.id}>
          {record.name || record.id} · {record.rep || 'Unassigned'}
        </option>)}
      </select>
    </label>
    <p role="status">{selected
      ? `Selected record ${selected.id}. Assignee: ${selected.record.rep || 'Unassigned'}. Existing access and title gates still apply.`
      : 'No record selected. This summary cannot create artwork, quote, send, or change a record.'}</p>
    <div className={styles.actions} role="group" aria-label="Selected member review actions">
      <button className="btn" type="button" disabled={!selected} onClick={() => {
        const actual = selectedMemberRow(summary, selectedId)
        if (actual && actual.record === choice?.record) onOpen?.(actual)
      }}>Open selected record</button>
      {REVIEW_ACTIONS.map((action) => <button className="btn" type="button" key={action.kind}
        disabled={!selected} onClick={() => choose(action)}>{action.label}</button>)}
    </div>
  </div>
}
